import { render, staticRenderFns } from "./revenue_list.vue?vue&type=template&id=2bfea0f2"
import script from "./revenue_list.vue?vue&type=script&lang=js"
export * from "./revenue_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports